// Повертаємо href лише для абсолютних http(s)-URL; будь-що інше (javascript:, data:,
// відносні шляхи, порожнє, не-рядок) трактуємо як відсутній лінк → null.
export default function safeUrl(url) {
	return typeof url === "string" && /^https?:\/\//.test(url) ? url : null;
}
